import { useTranslation } from 'react-i18next'

export default () => {
  const [t] = useTranslation('ttcmWarning')

  return (
    <section className="ttcm-warning">
      <h5>
        <strong>
          <i className="mr-2 fa-solid fa-bookmark" style={{ color: 'var(--gold)' }}></i>
          {t('title')}
        </strong>
      </h5>
      <p className="mb-3">{t('subTitle')}</p>
      <p className="mb-2">{t('titleSteps')}</p>
      <p dangerouslySetInnerHTML={{ __html: t('step1') }} />
      <p dangerouslySetInnerHTML={{ __html: t('step2') }} />
      <p dangerouslySetInnerHTML={{ __html: t('step3') }} />
      <p dangerouslySetInnerHTML={{ __html: t('step4') }} />
    </section>
  )
}
